var selector = '.js-disable-after-click',
    $button = $(selector);

/**
 * Handle the submit
 */
var handleButtonClick = function handleButtonClick(e) {
    e.preventDefault();

    var
        // get the button clicked
        $clicked = $(this),

        // find the form surrounding the button
        $form = $clicked.closest('form');

 
    // Check if form valid before disabling submit 
    var formValid = true;  
    formValid = $form.valid();  
    if (!formValid) return;  
 
        
    // disable the submit button
    $clicked.prop('disabled', true);

    // submit the form
    $form.submit();
}

/**
 * set Bindhandlers. in this case just check for button clicks
 */
var bindHandlers = function bindHandlers() {
    if ($button.length) {
        $('body').on('click', selector, handleButtonClick);
    }
}

/**
 * check if we need to initialise
 */
$(bindHandlers);